import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
import { useId } from "react";
/**
 * Can be sized by setting height only
 */
const SvgComponent = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => {
  // Dynamic mask id, sometimes required
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const id = useId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={undefined}
      height={18}
      fill="none"
      viewBox="0 0 18 18"
      aria-hidden="true"
      focusable="false"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="m9.724 1.57 1.457 3.69a.9.9 0 0 0 .783.568l3.959.247c.816.05 1.149 1.074.518 1.595l-3.057 2.526a.9.9 0 0 0-.3.92l.989 3.84c.204.793-.667 1.426-1.357.987l-3.347-2.127a.9.9 0 0 0-.968 0l-3.347 2.127c-.69.439-1.561-.194-1.357-.986l.989-3.841a.9.9 0 0 0-.3-.92L1.33 7.67c-.63-.521-.298-1.545.519-1.595l3.958-.247a.9.9 0 0 0 .783-.568l1.457-3.69c.3-.76 1.377-.76 1.678 0"
        clipRule="evenodd"
      />
    </svg>
  );
};
const ForwardRef = forwardRef(SvgComponent);
const Memo = memo(ForwardRef);
export default Memo;
